"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _StyleConfig = require("../utils/StyleConfig");
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _excluded = ["className", "use16Cols"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-col';

/**
 * The **Col** component is used in conjunction with **LayoutGrid**, **Row**
 * and **Clearfix** components for page layout using a 12 (default) or 16 column grid system.
 * It defines a column within a row in the grid.
 */

var Col = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Col, _props)) : _props;
  var className = props.className,
    use16Cols = props.use16Cols,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = [];
  var prefix = use16Cols ? CSS_BLOCK : 'col';
  var hiddenPrefix = use16Cols ? "".concat(CSS_BLOCK, "-") : '';
  _StyleConfig.VIEWPORT_SIZES.forEach(function (size) {
    var processProp = function processProp(propSuffix, modifier) {
      var _context;
      var propName = (0, _concat.default)(_context = "".concat(size)).call(_context, propSuffix);
      var propValue = otherProps[propName];
      if (propValue || propValue === 0) {
        if (use16Cols && size !== 'xs' || !use16Cols && size !== 'xl' && size !== 'xxl') {
          var _context2, _context3, _context4;
          classes.push((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(prefix, "-")).call(_context4, size)).call(_context3, modifier, "-")).call(_context2, propValue));
        }
      }
      delete otherProps[propName];
    };
    processProp('', '');
    processProp('Offset', '-offset');
    processProp('Push', '-push');
    processProp('Pull', '-pull');
    var hiddenPropName = "".concat(size, "Hidden");
    if (otherProps[hiddenPropName]) {
      if (use16Cols && size !== 'xs' || !use16Cols && size !== 'xl' && size !== 'xxl') {
        var _context5;
        classes.push((0, _concat.default)(_context5 = "".concat(hiddenPrefix, "hidden-")).call(_context5, size));
      }
    }
    delete otherProps[hiddenPropName];
  });
  var columnClasses = (0, _classnames.default)(classes, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: columnClasses,
    ref: ref
  }));
});
Col.displayName = 'Col';
Col.propTypes = {
  /** Custom classes to add to the column’s `<div>` tag. */
  className: _propTypes.default.string,
  /** Number of grid columns to span on large viewports. */
  lg: _propTypes.default.number,
  /** When true, grid column is hidden on large viewports. */
  lgHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on large viewports. */
  lgOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on large viewports. */
  lgPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on large viewports. */
  lgPush: _propTypes.default.number,
  /** Number of grid columns to span on medium viewports. */
  md: _propTypes.default.number,
  /** When true, grid column is hidden on medium viewports. */
  mdHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on medium viewports. */
  mdOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on medium viewports. */
  mdPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on medium viewports. */
  mdPush: _propTypes.default.number,
  /** Number of grid columns to span on small viewports. */
  sm: _propTypes.default.number,
  /** When true, grid column is hidden on small viewports. */
  smHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on small viewports. */
  smOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on small viewports. */
  smPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on small viewports. */
  smPush: _propTypes.default.number,
  /** Number of grid columns to span on extra small viewports
   * (default 12 column grid only). */
  xs: _propTypes.default.number,
  /** When true, grid column is hidden on extra small viewports
   * (default 12 column grid only). */
  xsHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on extra small viewports
   * (default 12 column grid only). */
  xsOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on extra small viewports
   * (default 12 column grid only). */
  xsPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on extra small viewports
   * (default 12 column grid only). */
  xsPush: _propTypes.default.number,
  /** Number of grid columns to span on extra large viewports (16 column grid only). */
  xl: _propTypes.default.number,
  /** When true, grid column is hidden on extra large viewports (16 column grid only). */
  xlHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on extra large viewports
   * (16 column grid only). */
  xlOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on extra large viewports
   * (16 column grid only). */
  xlPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on extra large viewports
   * (16 column grid only). */
  xlPush: _propTypes.default.number,
  /** Number of grid columns to span on double extra large viewports (16 column grid only). */
  xxl: _propTypes.default.number,
  /** When true, grid column is hidden on double extra large viewports (16 column grid only). */
  xxlHidden: _propTypes.default.bool,
  /** Number of grid columns to move to the right on double extra large viewports
   * (16 column grid only). */
  xxlOffset: _propTypes.default.number,
  /** Change the order of grid columns to the left on double extra large viewports
   * (16 column grid only). */
  xxlPull: _propTypes.default.number,
  /** Change the order of grid columns to the right on double extra large viewports
   * (16 column grid only). */
  xxlPush: _propTypes.default.number,
  /** Internal Use Only */
  use16Cols: _propTypes.default.bool
};
var _default = exports.default = Col;